import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { Invoice } from "../types";

async function getInvoices(workspaceId: string): Promise<Invoice[]> {
  return (await get(`workspaces/${workspaceId}/invoices`)).invoices;
}

export default function useInvoices() {
  const {
    id: workspaceId,
    subscription,
    rental_subscription,
  } = useSelectedWorkspaceContext();
  const { invoicesKeys } = getQueryKeys(workspaceId);

  const {
    data: invoices,
    isLoading: isLoadingInvoices,
    isError: isInvoicesError,
    refetch: refetchInvoices,
  } = useQuery({
    queryKey: invoicesKeys.list,
    queryFn: () => getInvoices(workspaceId),
    enabled: !!subscription || !!rental_subscription,
  });

  return {
    invoices,
    isLoadingInvoices,
    isInvoicesError,
    refetchInvoices,
  };
}
